export { default as QuickBookingRestShortB } from './QuickBookingRestShortB'
export { default as QuickBookingRestShortBSkeleton } from './Skeleton'
